import type { IRegDataStagedChange } from "../../../customTypings/spreadsheetTemplate/SpreadsheetTemplate";
import { removeStagedChange } from "./regDataAlignmentState";

/** Un-stage one change; used before re-running preview validation from the review modal. */
export function revertStagedChange(
    stagedChanges: IRegDataStagedChange[],
    changeKey: string
): IRegDataStagedChange[] {
    return removeStagedChange(stagedChanges, changeKey);
}

/** When no staged changes remain, preview validation should be cleared rather than re-fetched. */
export function shouldClearPreviewAfterRevert(stagedChanges: IRegDataStagedChange[]): boolean {
    return stagedChanges.length === 0;
}
